import React from 'react';

const Banner = () => (
  <section className="banner">
    <div className="container banner-container">
      <div className="banner-content wow fadeInUp">
        <span className="sub-title">Добро пожаловать в гостевой дом</span>
        <h1 className="title-1 logo">
          <span className="logo-item">DOM</span>
          {' YALTA'}
        </h1>
        <span className="sub-title">Лучший отпуск в Крыму</span>
      </div>
    </div>
  </section>
);

export default Banner;
